<div class="container-billing">
  <span class="title">Datos de facturación</span>
  <ng-container *ngIf="isLoading; else content">
    <div class="spinner-container">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="!hasBillingInfo; else noBillingInfo">
      <form class="bodyForm" [formGroup]="subscriptionForm">
        <div class="flex-auto">
          <label for="email"> Email </label>
          <input pInputText type="text" formControlName="email" id="email" [readonly]="true" />
        </div>
        <div class="flex-auto">
          <label for="name"> Nombre y Apellido </label>
          <input
            pInputText
            formControlName="name"
            id="name"
            formControlName="name"
            [readonly]="true"
          />
        </div>
        <div class="flex-auto">
          <label for="document_value"> RUT </label>
          <input
            pInputText
            formControlName="document_value"
            id="document_value"
            formControlName="document_value"
            (blur)="onblur()"
            [readonly]="true"
          />
        </div>
        <div class="flex-auto phone-input-container">
          <label for="phone">Teléfono</label>
          <div class="phone-input">
            <select
              formControlName="country"
              (change)="onCountryChange($event)"
              class="country-selector"
              style="height: 40px; border: 1px solid var(--color-border-light); font-size: 25px"
              [disabled]="true"
            >
              <option *ngFor="let country of countries" [value]="country.dial_code">
                {{ country.flag }}
              </option>
            </select>
            <span>{{ getCodeNumber() }}</span>
            <input
              type="tel"
              formControlName="phone"
              pKeyFilter="int"
              id="phone"
              class="phone-input-field"
              style="height: 40px; border-radius: 6px"
              [readonly]="true"
            />
          </div>
        </div>
      </form>
    </ng-container>
  </ng-template>

  <ng-template #noBillingInfo>
    <p>Actualmente, no tienes datos de facturación registrados.</p>
  </ng-template>
</div>
